import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import axios, { MEDIA_BASE_URL } from "../../axios/axios";
import Navbar from "../Navbar";
import Footer from "../Footer";

const data = [
  {
    img: "https://oes.pinnacleedits.com/public/productimg/1598629933_Simple.jpg",
    title: "Smart Album Design",
    price: "$ 0.90",
    path: "Commercial/E-Commerce Retouching/Commercial E-Commerce Product Retouching",
  },
  {
    img: "https://oes.pinnacleedits.com/public/productimg/1598629992_Mediumpro.jpg",
    title: "Wedding Album Design",
    price: "$ 5.00",
    path: "Commercial/E-Commerce Retouching/Commercial E-Commerce Product Retouching",
  },
  {
    img: "https://oes.pinnacleedits.com/public/productimg/1598630057_Hardpro.jpg",
    title: "Wedding Album Design",
    price: "$ 5.00",
    path: "Commercial/E-Commerce Retouching/Commercial E-Commerce Product Retouching",
  },
  {
    img: "https://oes.pinnacleedits.com/public/productimg/1598630177_Apparel.jpg",
    title: "Wedding Album Design",
    price: "$ 5.00",
    path: "Commercial/E-Commerce Retouching/Commercial E-Commerce Product Retouching",
  },
  {
    img: "https://oes.pinnacleedits.com/public/productimg/1598630310_FootwearEcommerce.jpg",
    title: "Wedding Album Design",
    price: "$ 5.00",
    path: "Commercial/E-Commerce Retouching/Commercial E-Commerce Product Retouching",
  },
];
const VideoEditingOrder = () => {
  const [services, setServices] = useState([]);
  const getServices = useCallback(async () => {
    try {
      const response = await axios.get("/services/getServices");
      // console.log()
      setServices(response.data.services);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getServices();
  }, [getServices]);

  return (
    <>
      <Navbar />
      <div className="order_bg">
        <h1>Order</h1>
      </div>
      <h2 className="text-center my-4 prata-regular">Video Editing </h2>

      <div className="mx-5 py-5">
        <div className="row">
          {services
            ?.filter((service) => service.service === "Video Editing")
            .map((val, index) => (
              <div key={index} className="col-md-3">
                <Link
                  to={`/videoediting-form/${val.id
                    .replaceAll(" ", "-")
                    .replaceAll("/", "_")}`}
                  className="border-1 card text-decoration-none pt-5"
                >
                  <img
                    src={`${MEDIA_BASE_URL}/${val.image}`}
                    crossOrigin="anonymous"
                    style={{ width: "100%", height: "18rem" }}
                    className="object-fit-cover"
                    alt=""
                  />
                  <div className="px-3">
                    <h5 className="py-4 mb-0 prata-regular">{val.title}</h5>
                    <p className=""> ${val.price}</p>
                  </div>
                  <p
                    className="mb-0 py-3 fs-14 px-3 prata-regular"
                    style={{ borderTop: "1px solid #ccc" }}
                  >
                    {val.description}
                  </p>
                </Link>
              </div>
            ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default VideoEditingOrder;
